import {IConfigSchema,} from '@/containers/FdcMilanoVolunteers/resources/config-schema';
import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';
import {getIndicators} from '@/containers/FdcMilanoVolunteers/Charts/VolunteerActivation/calculations';

interface IConfigSchemaProps {
    submissions: ISubmissionProps[]
}

export const configSchema = ({submissions}: IConfigSchemaProps): IConfigSchema => ({
    title: 'I. ATTIVAZIONE DEI VOLONTARI',
    tooltip: 'Il visual mostra il confronto tra i volontari effettivamente attivati dal ' +
        'progetto e il corrispondente valore atteso, nel complesso e per tipologia (75' +
        ' volontari, tra cui: 25 anziani silver (over 60), 15 studenti universitari, 30' +
        'lavoratori in azienda). I valori effettivi sono ottenuti grazie al conteggio e' +
        'alle caratteristiche indicate all’interno della “Scheda di Monitoraggio per la' +
        'rilevazione del profilo dei volontari”.',
    type: 'column',
    categories: ['Volontari totali', 'Volontari anziani silver', 'Volontari studenti universitari', 'Volontari lavoratori'],
    series: [
        {
            color: COLORS.blue,
            name: 'Valore Effetivo',
            data: getIndicators(submissions)
        },
        {
            color: COLORS.red,
            name: 'Valore Atteso',
            data: [75, 25, 15, 30]
        },
    ],
});